export default __webpack_public_path__ + "8291ed778ed388690455373c28eaf2c9.png";